import React from 'react';
import { View, SxProp } from 'dripsy';

import { TextAmount, TextBody, TextSmall } from '@/design-system/components/typography';
import { UniSkeleton } from '@/design-system/components/cards/UniSkeleton';
export interface UniAmountDetails {
  status?: 'default' | 'success' | 'danger';
  subText?: string;
  shouldHide?: boolean;
  name: string;
  currency: string;
  amount: string;
  amountPrefix?: string;
  subAmount?: string;
  subAmountPrefix?: string;
  subAmountCurrency?: string;
  loading?: boolean;
}

export interface UniAmountDetailsCardProps {
  data: Array<UniAmountDetails>;
  sx?: SxProp;
}

export const UniAmountDetailsCard: React.FC<UniAmountDetailsCardProps> = (props) => {
  const { data, sx } = props;

  if (!data) return null;

  return (
    <View sx={{ ...sxStyles.container, ...sx }}>
      {data.map((item, i) => (
        <UniAmountDetailsItem {...item} key={i} />
      ))}
    </View>
  );
};

const UniAmountDetailsItem: React.FC<UniAmountDetails> = (props) => {
  const {
    name,
    amount,
    subText,
    status = 'default',
    currency,
    shouldHide,
    amountPrefix,
    subAmount,
    subAmountPrefix,
    subAmountCurrency,
    loading
  } = props;

  return (
    <View sx={sxStyles.amountDetailsItem}>
      <View>
        <TextBody secondary>{name}</TextBody>
        {subText && <TextSmall secondary>{subText}</TextSmall>}
      </View>
      {loading && <UniSkeleton style={{ height: 17, width: 130 }} />}
      {!loading && (
        <View sx={{ alignItems: 'flex-end' }}>
          <TextAmount
            size="textBody"
            currency={currency}
            success={status === 'success'}
            danger={status === 'danger'}
            prefix={amountPrefix}
            shouldHide={shouldHide}>
            {amount}
          </TextAmount>
          {subAmount && (
            <TextAmount size="textCaption" currency={subAmountCurrency} secondary={true} prefix={subAmountPrefix} shouldHide={shouldHide}>
              {subAmount}
            </TextAmount>
          )}
        </View>
      )}
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center'
  },
  amountDetailsItem: {
    mt: 8,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
};
